export const getEventCard = (item) => {
  let startMonth = '', startDay = '', startWeekday = '', startTime = '';
  if (item.start) {
    if (item.recurrence && item.recurrence.startsWith('DTSTART')) {
      return (
        <div className='cal_date'>
          <span className='cal_month'>Recurring</span>
          <span className='cal_day'>Event</span>
          <span className='cal_wkday'>&nbsp;</span>
        </div>
      );
    }
    const parsedDate = new Date(Date.parse(item.start));
    startMonth = `${parsedDate.toLocaleString('default', { month: 'long' })}`;
    startDay = `${parsedDate.getDate()}`;
    startWeekday = `${parsedDate.toLocaleString('default', { weekday: 'long' })}`;
    startTime = `${parsedDate.toLocaleString('default', {
      hour: 'numeric', minute: 'numeric', hour12: true,
    })}`;
  }
  return (
    <div className='cal_date'>
      <span className='cal_month'>{startMonth}</span>
      <span className='cal_day'>{startDay}</span>
      <span className='cal_wkday'>{startWeekday}</span>
    </div>
  );
};

const SHORT_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const getEventDate = (item) => {
  let start = '', end = '';
  const fmt = (d) =>
    `${d.getDate()} ${SHORT_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  if (item.start) {
    start = fmt(new Date(Date.parse(item.start)));
  }
  if (item.end) {
    end = fmt(new Date(Date.parse(item.end)));
  }
  // If start and end are the same day, only show the start date
  if (start === end) {
    return start;
  } else {
    return end ? `${start} – ${end}` : start;
  }
};

const isAllDayEvent = (item) => {
  // Check 1: Plone's whole_day field (may not be present in listing brains)
  if (item.whole_day === true) return true;

  // Check 2: Detect from the time values themselves, since whole_day is often
  // stripped from search/listing brain results.
  // A full-day event in Plone has start at 00:00 and end at 23:59 the same day,
  // or end at 00:00 the following day (open-ended interval).
  if (item.start) {
    const startDate = new Date(Date.parse(item.start));
    const startH = startDate.getHours();
    const startM = startDate.getMinutes();

    if (startH === 0 && startM === 0) {
      if (item.end) {
        const endDate = new Date(Date.parse(item.end));
        const endH = endDate.getHours();
        const endM = endDate.getMinutes();
        // End at 23:59 same day, or midnight of the next day
        if ((endH === 23 && endM === 59) || (endH === 0 && endM === 0)) {
          return true;
        }
      } else {
        // Start at midnight with no end time — treat as all-day
        return true;
      }
    }
  }

  return false;
};

export const getEventTime = (item) => {
  if (isAllDayEvent(item)) return null;

  let start = '', end = '';
  if (item.start) {
    const parsedDate = new Date(Date.parse(item.start));
    start = `${parsedDate.toLocaleString('default', {
      hour: 'numeric', minute: 'numeric', hour12: true,
    })}`;
  }
  if (item.end) {
    const parsedEndDate = new Date(Date.parse(item.end));
    end = `${parsedEndDate.toLocaleString('default', {
      hour: 'numeric', minute: 'numeric', hour12: true,
    })}`;
  }
  return end ? `${start} – ${end}` : start;
};
